import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-festivals',
  templateUrl: './festivals.component.html',
  styleUrls: ['./festivals.component.scss']
})
export class FestivalsComponent implements OnInit {

  festivals = [
    {
      titre: 'Les Jeux du Graoully',
      logo: 'assets/img/festivals/graoully.png', // Correction du chemin
      ville: 'Metz',
      lieu: 'Stade Saint Symphorien',
      mois: 'Mai',
      lien: ['https://www.bylesjeuxdustan.fr/les-jeux-du-graoully/']
    },
    {
      titre: 'Les Jeux du Stan',
      logo: 'assets/img/festivals/stan.png',
      ville: 'Nancy',
      lieu: 'Stade Marcel Picot',
      mois: 'Novembre',
      lien: ['https://www.bylesjeuxdustan.fr/les-jeux-du-stan/']
    },
    {
      titre: 'Les Jeux du Roc',
      logo: 'assets/img/festivals/roc.png',
      ville: 'Pont-à-Mousson',
      lieu: 'Espace Montrichard',
      mois: 'Septembre / Octobre',
      lien: ['https://www.bylesjeuxdustan.fr/les-jeux-du-roc/']
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}